import morganStanleyStill from '../assets/images2022/MORGAN STANLEY.jpg';
import milestoneStill from '../assets/images2022/MILESTONE.jpg';
import gileadStill from '../assets/images2022/GILEAD.jpg';
import desCanStill from '../assets/images2022/DESTINATION CANADA.jpg';
import desCanHubStill from '../assets/images2022/DESTINATION CANADA-HUB-1.jpg';
import dreamworksStill from '../assets/images2022/LENOVO.jpg';
import expediaStill from '../assets/images2022/EXPEDIA.jpg';
import tillStill from '../assets/images2022/TIL.jpg';
import leroyStill from '../assets/images2022/sleepnumber.jpg';
import msHubStill from '../assets/images2022/MORGAN STANLEY HUB.jpg';
import intelHubStill from '../assets/images2022/INTEL HUB.jpg';
import aiscoutStill from '../assets/images2022/AWS.jpg';
import lexusStill from '../assets/images2022/LEXUS.jpg';

export const data = [
  {
    theme: '01',
    video: '779359757',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/MORGAN+STANLEY.mp4',
    poster: morganStanleyStill,
    preview: morganStanleyStill,
    brand: 'Morgan Stanley',
    title: 'Creating Space',
    description:
      "In 2019, the first all-female spacewalk was abruptly canceled due to a lack of spacesuits that fit the astronauts.<br/><br/>Space exploration should be for everyone. So <a href='https://www.linkedin.com/company/courageous-studios/' target='_blank' rel='noreferrer'>Courageous Studios</a> and Morgan Stanley partnered with space engineer Vinita Marwaha Madill and former astronaut Cady Coleman to build a prototype spacesuit designed to work for a wide range of bodies.<br><br/>A more inclusive tomorrow starts today.",
    quote: '',
    released: true
  },
  {
    theme: '02',
    video: '731078585',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/MILESTONE.mp4',
    poster: milestoneStill,
    preview: milestoneStill,
    brand: 'Ally',
    title: 'Milestone Generations',
    description:
      'In 1993, four Black creators changed the landscape of the comic book industry and pop culture by asking “Where are the Black superheroes?” The story of Milestone Media’s impact on a generation and its continuing legacy is finally being told. <br/><br/>The return of Milestone heroes to the pages of comic books was the inspiration for The Milestone Initiative -  a year-long program with Ally and DC Publishing to improve diversity in the comic book industry.<br/><br/>Milestone Generations, a feature-length doc, was the apex of this program, telling the story of the company, the people who founded it, and their lasting impact on a generation of superhero fans and creators. Watch it now on HBO Max.',
    quote: 'What will you do?',
    released: false
  },
  {
    theme: '03',
    video: '680613465',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/GILEAD.mp4',
    poster: gileadStill,
    preview: gileadStill,
    brand: 'Gilead',
    title: 'Blind Angels',
    description:
      'The AIDS epidemic is not over. More than 30,000 Americans are still diagnosed with HIV every year.<br/><br/>In the South, Black and Latinx LGBTQ+ communities bear the brunt of new infections. Racism, homophobia, and poverty fuel these numbers.<br/><br/>But across the South, selfless leaders are working within their communities to fight for the access, education, and resources that will help end the epidemic.'
  },
  {
    theme: '04',
    video: '771188792',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/LENOVO.mp4',
    // preview: charlesSchwabPreview,
    poster: dreamworksStill,
    brand: 'Lenovo + Intel',
    title: 'Creativity Unleashed',
    description:
      'Art and cinema take time, passion, talent—and, in this day and age—considerable computational horsepower.<br/><br/>In this film for Lenovo and Intel, discover how artists and filmmakers at DreamWorks Animation are pushing the boundaries of animation using cutting-edge technology.',
    quote: ''
  },
  {
    theme: '05',
    video: '761671517',
    loop: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/DC.mp4',
    preview: desCanStill,
    poster: desCanStill,
    brand: 'Destination Canada',
    title: 'This is Canada: Episode 1',
    description:
      'Award-winning chef Kia Damon wants everyone to come see what Canada is all about—and how it has something for everyone.<br/><br/> In this film for Destination Canada, we follow Kia as she explores the diverse cuisine, stunning maritime beauty, and charm of Nova Scotia.',
    quote: 'Freedom is the radical act of living joyfully—and not making any apologies for it.'
  },

  {
    theme: '06',
    video: '696591816',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/EXPEDIA.mp4',
    // preview: invescoPreview,
    poster: expediaStill,
    brand: 'Expedia',
    title: 'Next Stop: Wine Hunting in Occitane, France',
    description:
      'Camille Rivière is a Brooklyn-based wine importer who travels frequently to learn more about the origins of her favorite wines. <br/><br/>In this film for Expedia, Camille travels through the historic wine-growing region of Occitanie in Southern France to meet with two of her growers, learn about local treasures, and make some new discoveries.',
    quote: ''
  },
  {
    theme: '07',
    video: '704676296',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/SLEEPNUMBER.mp4',
    preview: leroyStill,
    poster: leroyStill,
    brand: 'Sleep Number',
    title: 'Rising to the Challenge',
    description:
      'Leroy Cummins, a long-distance runner breaking barriers in his 70s, is living proof of the importance of quality sleep. <br/><br/> Today, he’s an inspiration to both his community and his daughter, who’s not only impressed by his athletic ability but also his commitment to a healthy, well-rested life.',
    quote: ''
  },
  {
    theme: '08',
    video: '761991264',
    loop: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/TILL.mp4',
    preview: tillStill,
    poster: tillStill,
    brand: 'United Artists',
    title: 'Reflections of Till',
    description:
      'To reflect on the legacy of Mamie and Emmett Till, we went to the school he attended in Chicago, now named the Emmett Till Fine and Performing Arts Magnet School, and talked to faculty and students.<br/><br/>Interwoven with footage from the feature film Till, our video interviews reveal a deeper insight and appreciation for Mamie’s loss, her courage, and her tireless work in the name of civil rights.',
    quote: ''
  },
  {
    theme: '09',
    video: '763958286',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/INTELAWS.mp4',
    preview: aiscoutStill,
    poster: aiscoutStill,
    brand: 'AWS + Intel',
    title: 'Passion by the Numbers',
    description:
      'How does a young person with talent get the attention of a professional soccer league? With AI, of course. AiSCOUT is a technology startup dedicated to finding soccer talent who might otherwise have been overlooked by traditional scouting methods. This film for AWS and Intel highlights AiSCOUT’s role in giving one young man a potentially life-changing opportunity.',
    quote: ''
  },
  {
    theme: '10',
    video: '678861260',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/lexus_dynIS4j6.mp4',
    visitUrl: 'https://sponsorcontent.cnn.com/interactive/intel/',
    preview: lexusStill,
    poster: lexusStill,
    brand: 'Lexus',
    title: 'Driven From Within',
    description:
      'Jessica Nabongo is the first Black woman to have travelled to every country in the world. We rode alongside her, as she explored some places closer to home with Lexus.<br/><br/>In this film, Jessica meets artwear designer Amy Deal Denet, a former fashion executive, who has recently dedicated her time to uplifting Navajo artisans and youth in New Mexico.',
    quote: ''
  },

  {
    theme: '11',
    video: '',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/morgan-stanley.mp4',
    visitUrl: 'https://sponsorcontent.cnn.com/interactive/morganstanley/creating-space/',
    preview: msHubStill,
    poster: msHubStill,
    brand: 'Morgan Stanley',
    title: 'A History of Spacesuit Design',
    description:
      'Join space engineer Vinita Marwaha Madill and former astronaut Cady Coleman as they work with a group of young scientists to test Morgan Stanley’s conceptual model spacesuit: The Access I.  A more inclusive tomorrow starts today.',
    quote: ''
  },
  {
    theme: '12',
    video: '',
    loop: 'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/DCHUB.mp4',
    visitUrl: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
    preview: desCanHubStill,
    poster: desCanHubStill,
    brand: 'Destination Canada',
    title: 'This is Canada',
    description:
      'Canada invites visitors to see life from a whole new point of view, with its incredible diversity of cultures, vibrant cities, and through its unique activities, foods, and natural beauty.<br/><br/>Follow three travelers as they embark on a life-changing trip through Nova Scotia, Ontario, and British Columbia and be inspired to find your own space for renewal, reconnection, and revelation in this wide and embracing country.',
    quote: ''
  },
  {
    theme: '13',
    video: '',
    loop:
      'https://courageous-cdn-media-bucket.s3.amazonaws.com/courageous-showcase-2022/intel-hub.mp4',
    visitUrl: 'https://sponsorcontent.cnn.com/interactive/intel/',
    preview: intelHubStill,
    poster: intelHubStill,
    brand: 'Intel',
    title: 'How Wonderful Is That?',
    description:
      'When placed in the right hands, technology can change the world. That’s why Intel isn’t just crafting the technology of tomorrow, they’re working tirelessly to make tech a more equitable, inclusive, and accessible space than ever before.<br/><br/>In this series of films and articles, we’ll meet real innovators and explore game-changing programs that show us how wonderful the future can be when built on ingenuity, imagination, and determination.',
    quote: ''
  }
];
